/*
*
* File JS componente Block Product Plan
*
*/

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-product-plan.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//
let blockProductPlans = document.querySelector('.block-product-plan');

const manageHeights = () => {

    let planItems = document.querySelectorAll('.block-product-plan__list-item');

    if (window.innerWidth > 767)
    {
        // Recupero le altezze
        let heightCard = 0;
    
        planItems.forEach(el => {
            let innerCardElHeight = el.querySelector('.inner-card__top').offsetHeight + el.querySelector('.inner-card__btm').offsetHeight
    
            if (innerCardElHeight > heightCard)
            {
                heightCard = innerCardElHeight;
            }
        });
    
    
        // Imposto le altezze
        planItems.forEach(el => {
            el.querySelector('.inner-card').style.height = heightCard + 'px';
        });
    }
    else
    {
        planItems.forEach(el => {
            el.querySelector('.inner-card').style.height = '';
        });
    }
}

const selectPlan = (evt) => {
    let type = evt.target.dataset.type;

    let formSelectType = document.querySelector('#select-interest');

    if (!formSelectType) return;

    formSelectType.value = type;
}

const blockProductPlan = () => {

    if (!blockProductPlans) return;

    setTimeout(() => {
        manageHeights();
    }, 100);

    window.addEventListener('resize', () => {
        manageHeights();
    })

    window.selectPlan = selectPlan;
}

export default blockProductPlan;

//--------------------------------------------------------------------//